import { createNamedActions } from 'utils/namedActionTypesProxy';

export const POPUP_ACTION_TYPE = createNamedActions('popup', {
  OPEN: 'OPEN',
  CLOSE: 'CLOSE',
});

export const openPopupAction = () => ({ type: POPUP_ACTION_TYPE.OPEN });

export const closePopupAction = () => ({ type: POPUP_ACTION_TYPE.CLOSE });
